// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/instructions.css
// module id = 526
// module chunks = 0